import { Typography } from "@mui/material";
import { useMemo } from "react";
import { ReportType, reportTypeToCaption } from "../../../../../../api/types/svTypes.ts";
import { ReportKind, ReportSource } from "../../../../../../api/types/workbookRuns.types";
import InfoBlockItem from "@entrilia/shared/components/reporting/workbook/InfoBlockItem";

interface Props {
  companyTitle: string;
  isReadonly: boolean;
  reportKind: ReportKind;
  reportSource: ReportSource;
  reportType: string;
  clientCode: string;
}

const InfoBlock = ({ reportKind, reportSource, companyTitle, isReadonly, reportType, clientCode }: Props) => {
  const source = useMemo(() => {
    let s = reportSource === ReportSource.BC ? "Fund Operations" : "SmartViews";
    if (reportKind === ReportKind.MasterDataReport) {
      s += ", Master Data";
    }
    return s;
  }, [reportKind, reportSource]);
  const smartViewsReportType = Object.values(ReportType).find((type) => type === reportType);

  return (
    <>
      <Typography variant="subtitle2" sx={{ mb: 0.1 }}>
        Info
      </Typography>
      {isReadonly ? (
        <InfoBlockItem name="Company Code" title={clientCode} />
      ) : (
        <InfoBlockItem name="Company" title={companyTitle} />
      )}
      <InfoBlockItem name="Source" title={source} />
      <InfoBlockItem
        name="Report Type"
        title={smartViewsReportType ? reportTypeToCaption[smartViewsReportType] : reportType}
      />
    </>
  );
};

export default InfoBlock;
